/**
 * Single import point for GSAP. Registers plugins and applies global config exactly once
 * (module evaluation is not affected by React StrictMode's double-invoked effects).
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

// Mobile browsers fire resize when the URL bar collapses; re-measuring triggers there causes jumps.
ScrollTrigger.config({ ignoreMobileResize: true });
// Lenis drives the ticker; lag smoothing would fight the scroll-linked timing.
gsap.ticker.lagSmoothing(0);

export { gsap, ScrollTrigger, useGSAP };
